import type { SiteData } from '../../shared/types/site.js';
import { t } from '../i18n.js';
import { renderPageCta, renderPageHero } from './shared.js';
import { $, escapeHtml } from '../utils/index.js';

export function renderOurWork(siteData: SiteData): void {
  const el = $('#page-our-work');
  if (!el) return;

  const work = siteData.ourWork ?? {};
  const projects = work.projects ?? [];

  el.innerHTML = `
    ${renderPageHero({
      label: t('ourwork.label'),
      title: t('ourwork.title'),
      intro: work.intro ?? '',
      kicker: 'What clients need to see',
      stack: ['Outcome framing', 'System type', 'Build quality'],
    })}
    <section class="section">
      <div class="container project-showcase project-showcase-wide">
        ${projects
          .map(
            (project, index) => `
              <article class="project-card animate-on-scroll" style="animation-delay: ${(index % 3) * 0.05}s">
                <div class="project-card-top">
                  <span class="project-category">${escapeHtml(project.category)}</span>
                  <span class="project-index">0${index + 1}</span>
                </div>
                <h3>${escapeHtml(project.name)}</h3>
                <p>${escapeHtml(project.description)}</p>
              </article>
            `
          )
          .join('')}
      </div>
    </section>
    ${renderPageCta({
      label: t('ourwork.label'),
      title: t('ourwork.cta.title'),
      body: t('ourwork.cta.body'),
      buttonLabel: t('ourwork.cta.button'),
      href: '/about-us',
    })}
  `;
}
